import { render, staticRenderFns } from "./addCourseCtr.vue?vue&type=template&id=2115036a&scoped=true"
import script from "./addCourseCtr.vue?vue&type=script&lang=js"
export * from "./addCourseCtr.vue?vue&type=script&lang=js"
import style0 from "./addCourseCtr.vue?vue&type=style&index=0&id=2115036a&prod&lang=less"
import style1 from "./addCourseCtr.vue?vue&type=style&index=1&id=2115036a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2115036a",
  null
  
)

export default component.exports